import React, { FunctionComponent, useCallback } from 'react';
import VariantCategoryTabs from '../../../../../common/components/variantSelector/variantTabs/VariantCategoryTabs';
import { useDispatch, useSelector } from 'react-redux';
import variantsListSelectors from '../../../../store/selectors/variantsListSelectors';

interface IVariantCategoryTabsContainerProps {
  setMarketingCategory: (category: string) => any;
  selectedMarketingCategory?: string;
}

const VariantCategoryTabsContainer: FunctionComponent<IVariantCategoryTabsContainerProps> = ({
  setMarketingCategory,
  selectedMarketingCategory,
}) => {
  const dispatch = useDispatch();
  const variantListError = useSelector(variantsListSelectors.getVariantsListError);
  const variantItems = useSelector(variantsListSelectors.getVariantListItems) ?? {};

  const setMarketingCategoryCallback = useCallback(
    (_e: React.SyntheticEvent, category: string) => {
      setMarketingCategory(category);
    },
    [dispatch],
  );

  if (variantListError) {
    // Error displayed in variant list.
    return null;
  }

  if (!selectedMarketingCategory || !variantItems) {
    // Loader displayed in variant list.
    return null;
  }

  return (
    <VariantCategoryTabs
      marketingCategories={Object.keys(variantItems)}
      selectedMarketingCategory={selectedMarketingCategory}
      setMarketingCategory={setMarketingCategoryCallback}
    />
  );
};

export default VariantCategoryTabsContainer;
